import './OverlayLoader.scss'

export const OverlayLoader = () => {
    return (
        <div className='OverlayLoader'>
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}
